export default {
  registerContactus(state, payload) {
    state.contactus.push(payload);
  },
};
